<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-divider>{{ $T('人员信息') }}</el-divider>
      <div class="actions">
        <el-button type="primary" icon="el-icon-plus" @click="openMemberDialog()">{{ $T('添加成员') }}</el-button>
      </div>

      <el-table :data="memberList" border stripe size="mini" style="width: 100%" :empty-text="$T('暂无数据')">
        <el-table-column :label="$T('职能')" min-width="200">
          <template slot-scope="scope">{{ funcTableLabel(scope.row.func) }}</template>
        </el-table-column>
        <el-table-column prop="full_name" :label="$T('全名')" min-width="140"></el-table-column>
        <el-table-column prop="birth_date" :label="$T('出生日期')" min-width="120"></el-table-column>
        <el-table-column prop="fig_license" :label="$T('FIG执照')" min-width="120"></el-table-column>
        <el-table-column prop="passport_number" :label="$T('护照号码')" min-width="150"></el-table-column>
        <el-table-column :label="$T('护照PDF')" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.pass_pdf.length > 0 ? $T('已上传') : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pass_expiry_date" :label="$T('护照到期日')" min-width="140"></el-table-column>
        <el-table-column :label="$T('国籍')" min-width="140">
          <template slot-scope="scope">{{ citizenshipTableLabel(scope.row.citizenship) }}</template>
        </el-table-column>
        <el-table-column :label="$T('照片')" min-width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.photo.length > 0 ? $T('已上传') : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$T('保险')" min-width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.insurance.length > 0 ? $T('已上传') : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$T('操作')" min-width="140" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openMemberDialog(scope.row, scope.$index)">{{ $T('编辑') }}</el-button>
            <el-button type="text" style="color: #f56c6c" @click="removeMember(scope.$index)">{{ $T('删除') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="footer-button">
        <el-button type="primary" :loading="saveLoading" @click="submitForm">{{ $T('保存') }}</el-button>
      </div>

      <el-dialog :title="editingIndex > -1 ? $T('编辑成员') : $T('添加成员')" :visible.sync="showMemberDialog" width="760px">
        <el-form :model="memberForm" :rules="memberRules" ref="memberFormRef" label-position="top" class="member-dialog-form">
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('职能')" prop="func">
                <el-select v-model="memberForm.func" :placeholder="$T('选择职能')" style="width: 100%">
                  <el-option v-for="item in functionOptionsList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$T('全名')" prop="full_name">
                <el-input v-model="memberForm.full_name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('出生日期')" prop="birth_date">
                <el-date-picker v-model="memberForm.birth_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$T('FIG执照')" prop="fig_license">
                <el-input v-model="memberForm.fig_license" :placeholder="$T('没有证件号用0代替')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('护照号码')" prop="passport_number">
                <el-input v-model="memberForm.passport_number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$T('护照到期日')" prop="pass_expiry_date">
                <el-date-picker v-model="memberForm.pass_expiry_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('国籍')" prop="citizenship">
                <el-select v-model="memberForm.citizenship" :placeholder="$T('选择国籍')" filterable style="width: 100%">
                  <el-option v-for="item in citizenshipOptionsList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item :label="$T('护照PDF')">
            <FileUploader :fileList="memberForm.pass_pdf" :limit="1" accept=".pdf"></FileUploader>
          </el-form-item>
          <el-form-item :label="$T('照片')" prop="photo">
            <PicUploader :fileList="memberForm.photo" :limit="1"></PicUploader>
          </el-form-item>
          <el-form-item :label="$T('保险')">
            <FileUploader :fileList="memberForm.insurance" :limit="1" accept=".pdf,.jpg,.jpeg,.png"></FileUploader>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="showMemberDialog = false">{{ $T('取消') }}</el-button>
          <el-button type="primary" @click="saveMember">{{ $T('确定') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<style scoped>
.actions {
  margin-bottom: 12px;
}
.footer-button {
  margin-top: 16px;
  text-align: center;
}
.member-dialog-form /deep/ .el-form-item__label {
  line-height: 20px;
  padding-bottom: 6px;
}
.member-dialog-form /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>

<script>
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';
import { PHONE_COUNTRY_OPTIONS } from '@/utils/phoneCountryOptions';
import { MEMBER_FUNCTION_OPTIONS } from '@/utils/memberFunctionOptions';

/** 旧版国籍枚举 → 与电话国家列表一致的 k */
const LEGACY_CITIZENSHIP = {
  CHINESE: '中国',
  AMERICAN: '美国',
  BRITISH: '英国',
};

function normalizeCitizenshipKey(val) {
  if (val == null || val === '') {
    return '中国';
  }
  const s = String(val);
  if (LEGACY_CITIZENSHIP[s]) {
    return LEGACY_CITIZENSHIP[s];
  }
  if (PHONE_COUNTRY_OPTIONS.some((o) => o.k === s)) {
    return s;
  }
  return null;
}

const createEmptyMember = () => ({
  func: 'Gymnast',
  full_name: '',
  birth_date: '',
  fig_license: '',
  passport_number: '',
  pass_pdf: [],
  pass_expiry_date: '',
  citizenship: '中国',
  photo: [],
  insurance: [],
});

export default {
  name: 'SaiApplyFormStep2',
  components: {
    PicUploader,
    FileUploader,
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        id: 0,
      },
      memberList: [],
      showMemberDialog: false,
      editingIndex: -1,
      memberForm: createEmptyMember(),
    };
  },
  computed: {
    functionOptionsList() {
      return MEMBER_FUNCTION_OPTIONS.map(function (item) {
        return {
          value: item.value,
          label: this.$T(item.labelKey),
        };
      }, this);
    },
    citizenshipOptionsList() {
      return PHONE_COUNTRY_OPTIONS.map((opt) => ({
        value: opt.k,
        label: this.$T(opt.k),
      }));
    },
    memberRules() {
      return {
        func: [{ required: true, message: this.$T('请选择职能'), trigger: 'change' }],
        full_name: [{ required: true, message: this.$T('请输入全名'), trigger: 'blur' }],
        birth_date: [{ required: true, message: this.$T('请选择出生日期'), trigger: 'change' }],
        fig_license: [{ required: true, message: this.$T('请输入FIG执照'), trigger: 'blur' }],
        passport_number: [{ required: true, message: this.$T('请输入护照号码'), trigger: 'blur' }],
        pass_expiry_date: [{ required: true, message: this.$T('请选择护照到期日'), trigger: 'change' }],
        citizenship: [{ required: true, message: this.$T('请选择国籍'), trigger: 'change' }],
        photo: [
          { required: true, message: this.$T('请上传照片'), trigger: 'change' },
          { validator: this.validatePhotoRequired, trigger: 'change' },
        ],
      };
    },
  },
  mounted() {
    this.formData.id = this.$route.query.id;
    document.title = this.$T('人员信息');
    if (this.formData.id) {
      this.fetch();
    }
  },
  methods: {
    validatePhotoRequired(rule, value, callback) {
      const list = value || this.memberForm.photo;
      if (!list || !Array.isArray(list) || list.length === 0) {
        callback(new Error(this.$T('请上传照片')));
        return;
      }
      callback();
    },
    citizenshipTableLabel(val) {
      const k = normalizeCitizenshipKey(val);
      if (k !== null) {
        return this.$T(k);
      }
      return val != null && val !== '' ? String(val) : '';
    },
    funcTableLabel(val) {
      if (val == null || val === '') {
        return '';
      }
      const s = String(val);
      for (let i = 0; i < MEMBER_FUNCTION_OPTIONS.length; i++) {
        if (MEMBER_FUNCTION_OPTIONS[i].value === s) {
          return this.$T(MEMBER_FUNCTION_OPTIONS[i].labelKey);
        }
      }
      return s;
    },
    fetch() {
      this.$api.post('/api/isai/step2detail', { id: this.formData.id }, (res) => {
        const list = (res.data && res.data.member_table_list) || [];
        this.memberList = list.map((item) => {
          var member = createEmptyMember();
          member.func = item.func || 'Gymnast';
          member.full_name = item.full_name || '';
          member.birth_date = item.birth_date || '';
          member.fig_license = item.fig_license || '';
          member.passport_number = item.passport_number || '';
          member.pass_pdf = item.pass_pdf || [];
          member.pass_expiry_date = item.pass_expiry_date || '';
          const ck = normalizeCitizenshipKey(item.citizenship);
          member.citizenship = ck !== null ? ck : (item.citizenship != null && item.citizenship !== '' ? String(item.citizenship) : '中国');
          member.photo = item.photo || [];
          member.insurance = item.insurance || [];
          member.id = item.id || 0;
          return member;
        });
      }, () => {
        this.memberList = [];
      });
    },
    openMemberDialog(row, index = -1) {
      this.editingIndex = index;
      this.memberForm = row ? JSON.parse(JSON.stringify(row)) : createEmptyMember();
      this.showMemberDialog = true;
      this.$nextTick(() => {
        if (this.$refs.memberFormRef) {
          this.$refs.memberFormRef.clearValidate();
        }
      });
    },
    saveMember() {
      this.$refs.memberFormRef.validate((valid) => {
        if (!valid) return;
        const payload = JSON.parse(JSON.stringify(this.memberForm));
        if (this.editingIndex > -1) {
          this.$set(this.memberList, this.editingIndex, payload);
        } else {
          this.memberList.push(payload);
        }
        this.showMemberDialog = false;
      });
    },
    removeMember(index) {
      this.$confirm(this.$T('确定删除该成员？'), this.$T('删除'), {
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        confirmButtonText: this.$T('确定'),
        cancelButtonText: this.$T('取消'),
      }).then(() => {
        this.memberList.splice(index, 1);
      }).catch(() => {});
    },
    submitForm() {
      if (this.memberList.length === 0) {
        this.$message.warning(this.$T('请至少添加一名成员'));
        return;
      }
      this.saveLoading = true;
      this.$api.post('/api/isai/memberSave', {
        baoming_id: this.formData.id,
        member_list: JSON.stringify(this.memberList),
      }, () => {
        this.$message.success(this.$T('保存成功'));
        this.saveLoading = false;
        rbLink({
          name: 'ISaiApplyDetail',
          query: {
            id: this.formData.id,
          },
        }, 'back');
      }, (res) => {
        this.$message.error(res.msg || this.$T('保存失败'));
        this.saveLoading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep2.vue?2d34cb4f